/**
 * Copyright (c) 2026-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Remix Icon License v1.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const ImageLine = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M3 21a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1zm17-6V5H4v14L14 9zm0 2.83-6-6L6.83 19H20zM8 11a2 2 0 1 1 0-4 2 2 0 0 1 0 4" />
  </Icon>
);
